import { CountryEnum, type CountryEnumType } from '@sr/types';
import { useProfileV2 } from 'core/lib/Profile';
import { useFlag } from './useFlag';

const hasCSRDAccessForCountry = (
  profileMarkets: {
    activeSweden: boolean;
    activeDenmark: boolean;
    activeFinland: boolean;
    activeNorway: boolean;
    activePoland: boolean;
  },
  csrdFlags: {
    csrdFlag: boolean;
    csrdAllowSweden: boolean;
    csrdAllowDenmark: boolean;
    csrdAllowFinland: boolean;
    csrdAllowNorway: boolean;
    csrdAllowPoland: boolean;
  },
) => {
  const countryMap: Record<CountryEnumType, boolean> = {
    [CountryEnum.SE]:
      profileMarkets.activeSweden && csrdFlags.csrdFlag && csrdFlags.csrdAllowSweden,
    [CountryEnum.DK]:
      profileMarkets.activeDenmark && csrdFlags.csrdFlag && csrdFlags.csrdAllowDenmark,
    [CountryEnum.FI]:
      profileMarkets.activeFinland && csrdFlags.csrdFlag && csrdFlags.csrdAllowFinland,
    [CountryEnum.NO]:
      profileMarkets.activeNorway && csrdFlags.csrdFlag && csrdFlags.csrdAllowNorway,
    [CountryEnum.PL]:
      profileMarkets.activePoland && csrdFlags.csrdFlag && csrdFlags.csrdAllowPoland,
  };

  return countryMap;
};

export const useCsrdCountryMap = () => {
  const { profile } = useProfileV2();
  const activeSweden = profile?.aggregatedPermissions.markets.sweden ?? false;
  const activeDenmark = profile?.aggregatedPermissions.markets.denmark ?? false;
  const activeFinland = profile?.aggregatedPermissions.markets.finland ?? false;
  const activeNorway = profile?.aggregatedPermissions.markets.norway ?? false;
  const activePoland = profile?.aggregatedPermissions.markets.poland ?? false;

  const csrdFlag = useFlag('csrd');
  const csrdAllowSweden = useFlag('csrd-allow-sweden');
  const csrdAllowDenmark = useFlag('csrd-allow-denmark');
  const csrdAllowFinland = useFlag('csrd-allow-finland');
  const csrdAllowNorway = useFlag('csrd-allow-norway');
  const csrdAllowPoland = useFlag('csrd-allow-poland');

  return hasCSRDAccessForCountry(
    {
      activeSweden,
      activeDenmark,
      activeFinland,
      activeNorway,
      activePoland,
    },
    {
      csrdFlag,
      csrdAllowSweden,
      csrdAllowDenmark,
      csrdAllowFinland,
      csrdAllowNorway,
      csrdAllowPoland,
    },
  );
};
